import Moment from 'moment-timezone'

export function canUpdateGrowingSeason(growingSeason) {
  if (!growingSeason?.sowing_date) return false

  return Moment(growingSeason.sowing_date).isSameOrBefore(Moment())
}

export function hasCalculatedGrowingSeasonData(growingSeason) {
  return !!growingSeason?.data_views?.length
}
